import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { depoEasyConfig, depoEasyInvestConfig } from '../../../environments/environment';
import { LoginService } from '../../service/login.service';

@Component({
    selector: 'app-depo-easy-invest',
    template: ''
})
export class DepoEasyInvestComponent implements OnInit {
  private activeConfig = depoEasyInvestConfig;

  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(async (params) => {
      const inApp = params['inApp'];
      // if (inApp) {
      //   depoEasyConfig.redirectUri = depoEasyConfig.redirectUri + '?inApp=true';
      // }
      const banner = params['banner'];
      let channel = params['channel'];

      const tenanthost = params['tenanthost'];
      if (tenanthost === 'eb') {
        channel = 'ebanking';
      }else{
        channel = 'app';
      }

      // option=1 → easy Depot (depoEasyConfig)
      // option=2 → easy Invest with /start/intro as entry point (depoEasyInvestConfig)
      // unset/invalid → easy Invest with standard /product-selection (depoEasyInvestConfig)
      // If the option is not available for the customer the downstream app handles the fallback
      const option = params['option'];
      const config = option === '1' ? depoEasyConfig : depoEasyInvestConfig;
      this.activeConfig = config;

      // option=2: go directly to /start/intro instead of /product-selection
      if (option === '2' && config.redirectUri) {
        config.redirectUri = config.redirectUri.replace('/product-selection', '/start/intro');
      }

      // Change redirect URL path from /product-selection (or /start/intro) to /native-selection for inApp or app cases
      if (inApp) {
        if (config.redirectUri) {
          config.redirectUri = config.redirectUri
            .replace('/start/intro', '/native-selection')
            .replace('/product-selection', '/native-selection');
        }
      }

      const queryParams = [];

      if (banner) {
        queryParams.push('banner=' + banner);
      }

      if (channel) {
        queryParams.push('channel=' + channel);
      }

      if (inApp) {
        queryParams.push('inApp=true');
      }

      if (option) {
        queryParams.push('option=' + option);
      }

      if (queryParams.length > 0) {
        config.redirectUri += '?' + queryParams.join('&');
      }
    });
  }

  ngOnInit(): void {
    this.loginService.login(this.activeConfig);
  }
}
